class ProductStickyAtc {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.actionButton = container.querySelector("[data-sticky-atc-button]");
    this.priceNode = container.querySelector("[data-sticky-price]");
    this.submitButton = document.getElementById(
      `ProductSubmitButton-${this.sectionId}`,
    );
    this.priceRoot = document.getElementById(`price-${this.sectionId}`);
    this.productInfo = document.getElementById(`ProductInfo-${this.sectionId}`);

    if (!this.submitButton || !this.productInfo || !this.actionButton) {
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);

    this.actionButton.addEventListener("click", this.onClick);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll);

    this.observer = new MutationObserver(() => this.syncState());
    this.observer.observe(this.submitButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    if (this.priceRoot) {
      this.observer.observe(this.priceRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    this.syncState();
    this.onScroll();
  }

  getPriceText() {
    if (!this.priceRoot) return "";
    const candidates = [
      ".price-item--sale",
      ".price-item--last",
      ".price-item--regular",
      ".price-item",
    ];

    for (const selector of candidates) {
      const node = this.priceRoot.querySelector(selector);
      if (node && node.textContent.trim()) {
        return node.textContent.trim();
      }
    }

    return "";
  }

  syncState() {
    const disabled = this.submitButton.hasAttribute("disabled");
    this.actionButton.disabled = disabled;

    const label = this.submitButton.querySelector("span")?.textContent?.trim();
    if (label) {
      this.actionButton.textContent = label;
    }

    const price = this.getPriceText();
    if (price && this.priceNode) {
      this.priceNode.textContent = price;
    }
  }

  onScroll() {
    if (window.innerWidth >= 990) {
      this.container.classList.remove("is-visible");
      return;
    }

    const rect = this.productInfo.getBoundingClientRect();
    const shouldShow = rect.top < -160;
    this.container.classList.toggle("is-visible", shouldShow);
  }

  onClick() {
    if (this.submitButton.disabled) return;
    this.submitButton.click();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-sticky-atc").forEach((container) => {
    new ProductStickyAtc(container);
  });
});
